import { API_BASE_URL, API_ENDPOINTS } from '../constants';

const DEFAULT_ERROR = 'No pudimos enviar tu mensaje. Intentá nuevamente más tarde.';

/**
 * Envía el formulario de contacto de la web. No usa apiClient porque esta página
 * se prerenderiza (SSR) y apiClient lee localStorage al importarse.
 */
export const sendContactMessage = async (data) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.CONTACT}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  } catch {
    throw new Error('No se pudo conectar con el servidor. Revisá tu conexión.');
  }

  const body = await response.json().catch(() => ({}));

  if (response.status === 429) {
    throw new Error('Enviaste varios mensajes seguidos. Esperá un rato e intentá de nuevo.');
  }
  if (!response.ok || !body.success) {
    throw new Error(body.message || DEFAULT_ERROR);
  }
  return body;
};
